import ListProcesses from "@/views/agro_exporter/finances/query_container_incomes/ListProcesses.vue";
import ShowProcess from "@/views/agro_exporter/finances/query_container_incomes/ShowProcess.vue";
import ShowProcessContainers from "@/components/views/agro_exporter/finances/query_container_incomes/show_process/Containers.vue";
import ShowProcessExportInvoices from "@/components/views/agro_exporter/finances/query_container_incomes/show_process/ExportInvoices.vue";
import ShowContainer from "@/views/agro_exporter/finances/query_container_incomes/ShowContainer.vue";
import ShowExportInvoice from "@/views/agro_exporter/finances/query_container_incomes/ShowExportInvoice.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "ae",
  role: "finances",
  permission: "query_container_incomes"
});

export default [
  {
    path: "/ae/:agro_exporter_id/finances/query_container_incomes/list_processes",
    name: routeName(""),
    redirect: { name: routeName("list_processes") }
  },
  {
    path: "/ae/:agro_exporter_id/finances/query_container_incomes/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/finances/query_container_incomes/show_process/:agro_exporter_process_id",
    name: routeName("show_process"),
    redirect: { name: routeName("show_process_containers") },
    component: ShowProcess,
    props: true,
    meta: META,
    children: [
      {
        path: "containers",
        name: routeName("show_process_containers"),
        alias: "",
        component: ShowProcessContainers,
        props: true
      },
      {
        path: "export_invoices",
        name: routeName("show_process_export_invoices"),
        alias: "",
        component: ShowProcessExportInvoices,
        props: true
      }
    ]
  },
  {
    path: "/ae/:agro_exporter_id/finances/query_container_incomes/:agro_exporter_process_id/show_container/:container_id",
    name: routeName("show_container"),
    component: ShowContainer,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/finances/query_container_incomes/:agro_exporter_process_id/show_export_invoice/:export_invoice_id/:container_id",
    name: routeName("show_export_invoice"),
    component: ShowExportInvoice,
    props: true,
    meta: META
  }
];
